import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';

import GenericList from '@ts-core/core/components/GenericList';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';

import StudentAssignmentCard from '@ts-core/modules/assignments/components/StudentAssignmentCard';
import { StudentAssignment } from '@ts-core/modules/assignments/types';

import { useStudentAssignments } from '../../hooks';

const StudentCourseAssignmentsPage = () => {
  const history = useHistory();

  const { courseId, studentId } = useParams<{ courseId: string; studentId: string }>();

  const { studentAssignments, loading } = useStudentAssignments({ courseId, studentId });

  const onSelectAssignment = useCallback(
    (assignment: StudentAssignment) => {
      history.push(`assignments/${assignment.id}`);
    },
    [history]
  );

  return (
    <PageContentLayout>
      <GenericList
        items={studentAssignments}
        loading={loading}
        skeletonsCount={2}
        emptyMessage="El estudiante aún no ha hecho ninguna entrega."
        renderItem={(index, assignment) => (
          <StudentAssignmentCard key={assignment?.id || index} assignment={assignment} loading={loading} onAssignmentClick={onSelectAssignment} />
        )}
      />
    </PageContentLayout>
  );
};

StudentCourseAssignmentsPage.propTypes = {
  student: PropTypes.object,
  loading: PropTypes.bool,
};

StudentCourseAssignmentsPage.defaultProps = {
  student: {},
  loading: false,
};

export default StudentCourseAssignmentsPage;
